import type { EditorCanvas } from "replo-utils/lib/misc/canvas";

import React from "react";

import { Button } from "@replo/design-system/components/button/Button";
import { Tooltip } from "@replo/design-system/components/tooltip/Tooltip";
import { useViewportStore } from "@v2/features/page-renderer/store/viewportStore";
import { CANVAS_SIZES } from "@v2/utils/canvas-size";
import { MonitorSmartphone } from "lucide-react";

interface ResponsiveControlsProps {
  variant?: "primary" | "secondary" | "tertiary" | "destructive" | "link";
}

function ResponsiveControls({ variant = "tertiary" }: ResponsiveControlsProps) {
  const { currentViewport, setCurrentViewport } = useViewportStore();

  const handleViewportToggle = () => {
    const nextViewport: EditorCanvas =
      currentViewport === "mobile" ? "desktop" : "mobile";
    setCurrentViewport(nextViewport);
  };

  const getTooltipText = () => {
    const nextViewport: EditorCanvas =
      currentViewport === "mobile" ? "desktop" : "mobile";
    const nextWidth = CANVAS_SIZES[nextViewport].defaultFrameWidth;
    return `Switch to ${nextViewport} (${nextWidth}px)`;
  };

  return (
    <div className="flex items-center gap-2">
      <Tooltip content={getTooltipText()} triggerAsChild>
        <Button
          icon
          variant={variant}
          size="base"
          UNSAFE_className="max-sm:size-10"
          onClick={handleViewportToggle}
        >
          <MonitorSmartphone />
        </Button>
      </Tooltip>
    </div>
  );
}

export default ResponsiveControls;
